import styled from 'styled-components';
import {theme} from './../../../styles/theme'

interface ResponsiveProps {
    isDesktopOrLaptop?: boolean;
    isMiniNotebook?: boolean;
    isMobileBig?: boolean;
    isMobileMedium?: boolean;
    isMobileMini?: boolean;
  }

export const Input = styled.input<ResponsiveProps>`
    padding: ${({ isMobileMini, isMobileMedium }) =>
    isMobileMini ? '2px' : isMobileMedium ? '4px' : '6px'};
    height: ${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook }) =>
      isMobileMini ? '16px' : isMobileMedium ? '20px' : isMobileBig ? '20px' : isMiniNotebook ? '20px' : '20px'};
  font-size: ${({ isMobileMini, isMobileMedium, isMobileBig }) =>
    isMobileMini ? '10px' : isMobileMedium ? '12px' : isMobileBig ? '14px' : '15px'};
  width: ${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook }) =>
    isMobileMini
      ? '80px'
      : isMobileMedium
      ? '80px'
      : isMobileBig
      ? '120px'
      : isMiniNotebook
      ? '125px'
      : '150px'};
    border-radius: 6px;
    outline: none;
    border: 1px solid;
    background-color: #edebdd;
    border-color: ${({ theme }) => theme.colors.primary};


`

/*

    &:focus {
        border-color: ${({theme})=> theme.colors.secondary };
        outline: none;
    }
*/